import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-similar-job-view',
  templateUrl: './similar-job-view.component.html',
  styleUrls: ['./similar-job-view.component.scss']
})
export class SimilarJobViewComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
